import { useAuth } from '../contexts/AuthContext';

export interface WhiteLabel {
  /** Nom affiché dans la navbar, les pages publiques, les PDFs */
  appName: string;
  /** URL du logo (null → utiliser l'icône bouclier par défaut) */
  logoUrl: string | null;
  /** Slug de la company (ex: "optisecur") */
  slug: string;
  /** true si la company a personnalisé son nom (≠ OPTISECUR) */
  isCustomBrand: boolean;
  /** Email de contact affiché dans le footer et les pages légales */
  contactEmail: string;
}

const DEFAULT_APP_NAME = 'OptiSecur';
const DEFAULT_CONTACT_EMAIL = 'support@optisecur.com';

/**
 * Retourne les infos de marque blanche de la company de l'utilisateur connecté.
 * Si non connecté ou company non trouvée, retourne les valeurs OptiSecur par défaut.
 */
export function useWhiteLabel(): WhiteLabel {
  const { userProfile } = useAuth();

  const appName = userProfile?.company_name || DEFAULT_APP_NAME;
  const logoUrl = userProfile?.company_logo_url ?? null;
  const slug = userProfile?.company_slug ?? '';
  const isCustomBrand = !!appName && appName.toLowerCase() !== DEFAULT_APP_NAME.toLowerCase();
  const contactEmail = userProfile?.company_contact_email ?? DEFAULT_CONTACT_EMAIL;

  return { appName, logoUrl, slug, isCustomBrand, contactEmail };
}
